import HeaderSearchInput from "../components/search/HeaderSearchInput.vue";

if (document.getElementById('header-search-input')) {
  new Vue({
    el: '#header-search-input',
    components: {
      HeaderSearchInput
    },
  });
}
